/**
 * Stable CSS class names for E2E — Product comments / Comment list page.
 */
export const CL = {
    page: 'product-comments-comment-list-page',

    detailDrawerPaper: 'product-comments-comment-list-page__detail-drawer-paper',
    filterDrawerPaper: 'product-comments-comment-list-page__filter-drawer-paper',
    detailDrawerContent: 'product-comments-comment-list-page__detail-drawer-content',
    filterDrawerContent: 'product-comments-comment-list-page__filter-drawer-content',

    excelLoadingSection: 'product-comments-comment-list-page__excel-loading-section',
    excelLoadingBar: 'product-comments-comment-list-page__excel-loading-bar',

    filtersLayout: 'product-comments-comment-list-page__filters-layout',
    headerTitle: 'product-comments-comment-list-page__header-title',

    tagAutocompleteWrap: 'product-comments-comment-list-page-input--tag-autocomplete-wrap',
    dateRangeWrap: 'product-comments-comment-list-page-input--date-range-wrap',
    statusSelectWrap: 'product-comments-comment-list-page-input--status-select-wrap',
    grievanceSelectWrap: 'product-comments-comment-list-page-input--grievance-select-wrap',
    inputSpecialCode: 'product-comments-comment-list-page-input--special-code',
    inputColorCode: 'product-comments-comment-list-page-input--color-code',

    actionsWrap: 'product-comments-comment-list-page__actions-wrap',
    applyQuickFilterButton: 'product-comments-comment-list-page-input--button-apply-quick-filter',
    openAdvancedFilterButton: 'product-comments-comment-list-page-input--button-open-advanced-filter',
    exportExcelButton: 'product-comments-comment-list-page-input--button-export-excel',

    tablePaper: 'product-comments-comment-list-page__table-paper',
    gridWrap: 'product-comments-comment-list-page__grid-wrap',
} as const;

export const clCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

